import {
  type UpdateNotificationSettingsRequest,
  updateNotificationSettingsNotificationSettingsPut,
} from "@phc/common/gen/preferencesGen"
import { useMutation } from "@tanstack/react-query"
import { useSnackbar } from "notistack"

export const useUpdateNotificationSettings = () => {
  const { enqueueSnackbar } = useSnackbar()

  return useMutation({
    mutationFn: (variables: UpdateNotificationSettingsRequest) =>
      updateNotificationSettingsNotificationSettingsPut(variables),
    onError: (err: Error) => {
      enqueueSnackbar("Unable to update your notification settings.", {
        variant: "error",
      })
      console.error(err)
    },
  })
}
